
    import './styles.scoped.css';
    export default {
  "alert": "awsui_alert_mx3cw_xzff1_13",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_xzff1_1",
  "root": "awsui_root_mx3cw_xzff1_84",
  "hidden": "awsui_hidden_mx3cw_xzff1_119",
  "alert-wrapper": "awsui_alert-wrapper_mx3cw_xzff1_182",
  "initial-hidden": "awsui_initial-hidden_mx3cw_xzff1_194",
  "header": "awsui_header_mx3cw_xzff1_199",
  "header-replacement": "awsui_header-replacement_mx3cw_xzff1_200",
  "action": "awsui_action_mx3cw_xzff1_204",
  "action-slot": "awsui_action-slot_mx3cw_xzff1_208",
  "action-button": "awsui_action-button_mx3cw_xzff1_209",
  "alert-focus-wrapper": "awsui_alert-focus-wrapper_mx3cw_xzff1_213",
  "icon": "awsui_icon_mx3cw_xzff1_245",
  "text": "awsui_text_mx3cw_xzff1_249",
  "message": "awsui_message_mx3cw_xzff1_259",
  "action-wrapped": "awsui_action-wrapped_mx3cw_xzff1_263",
  "icon-size-medium": "awsui_icon-size-medium_mx3cw_xzff1_267",
  "icon-size-big": "awsui_icon-size-big_mx3cw_xzff1_271",
  "icon-size-normal": "awsui_icon-size-normal_mx3cw_xzff1_275",
  "content": "awsui_content_mx3cw_xzff1_279",
  "content-replacement": "awsui_content-replacement_mx3cw_xzff1_280",
  "dismiss": "awsui_dismiss_mx3cw_xzff1_284",
  "dismiss-button": "awsui_dismiss-button_mx3cw_xzff1_290",
  "type-error": "awsui_type-error_mx3cw_xzff1_294",
  "type-warning": "awsui_type-warning_mx3cw_xzff1_302",
  "type-success": "awsui_type-success_mx3cw_xzff1_310",
  "type-info": "awsui_type-info_mx3cw_xzff1_318"
};
  